<script setup lang="ts">
import { marked } from 'marked';
import FetchErrorRetry from '~/components/common/FetchErrorRetry.vue';

const {locale} = useI18n()
const markdownContent = ref('')
const loading = ref(true)
const fetchError = ref(null)
const isRetrying = ref(false)

// Function to fetch markdown content (using static English file)
async function fetchMarkdownContent() {
  try {
    loading.value = true
    fetchError.value = null
    isRetrying.value = false
    
    // Using static English privacy file instead of dynamic locale
    // const response = await fetch(`/content/${locale.value}/privacy.md`)
    const response = await fetch('/content/en/privacy.md')
    
    if (!response.ok) {
      throw new Error(`Failed to fetch privacy content: ${response.status}`)
    }
    
    const rawContent = await response.text()
    // Parse markdown to HTML using marked
    markdownContent.value = marked.parse(rawContent)
  } catch (error) {
    fetchError.value = error
  } finally {
    loading.value = false
  }
}

// Function to handle retry
function handleRetry() {
  isRetrying.value = true
  fetchMarkdownContent()
}

// Fetch content on component mount
onMounted(() => {
  fetchMarkdownContent()
})

// No need to re-fetch when locale changes since we're using static English file
// watch(() => locale.value, () => {
//   fetchMarkdownContent()
// })

const { t } = useI18n()

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    tr: '/gizlilik-politikasi',
    en: '/privacy',
    ar: '/الخصوصية',
    hi: '/गोपनीयता',
    ur: '/رازداری',
    vi: '/bao-mat',
    ru: '/конфиденциальность',
    de: '/datenschutz',
    es: '/privacidad',
    pt: '/privacidade',
    ne: '/गोपनीयता'
  }
})
</script>

<template>
  <div>
    <div class="container mx-auto px-4 py-20 my-10">
      <div v-if="!loading && !fetchError" class="max-w-3xl mx-auto">
        <div class="prose" v-html="markdownContent"></div>
      </div>
      <div v-else-if="loading" class="w-full h-[90svh] flex items-center justify-center">
        <PrimeProgressSpinner />
      </div>
      <div v-else-if="fetchError" class="w-full h-[90svh] flex items-center justify-center">
        <FetchErrorRetry
          :loading="isRetrying"
          @retry="handleRetry"
        />
      </div>
    </div>
  </div>
</template>

